import { FileSearch } from 'lucide-react';

// Shown when the dealer's visible tabs all resolve to nothing for this
// vehicle. Deliberately says nothing about the vehicle — falling back to a
// tab the dealer hid would leak exactly what they chose to suppress.
const SalesPacketEmptyState = () => (
  <div
    id="sales-packet-empty"
    className="mt-2 mb-5 w-full flex flex-col items-center justify-center py-20 text-center"
  >
    <FileSearch className="h-10 w-10 text-[#9e9e9e] mb-4" />
    <p className="text-base font-medium">No information available</p>
    <p className="text-sm text-[#616161] mt-2 max-w-md">
      There is nothing to display for this vehicle right now. Please contact the
      dealership for more information.
    </p>
  </div>
);

export default SalesPacketEmptyState;
